import DataLoader from "../Utlis/DataLoader";

const SectorPosts = async (category) => {
  try {
    const response = await DataLoader({
      Path: `/api/v1/posts/getposts/${category}`,
      Type: 'get'
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export default SectorPosts;
